import { debounce } from 'lodash';
import Marquee from '@/modules/Marquee/Marquee.js';
import delegate from 'delegate-it';

class PlacesList {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.marquee = null;

    this.config = {
      marqueePoint: 1300,
    };

    this.findElements();
    this.saveListBoxInitialDom();
    this.initUiState();
    this.init();
    this.attachEvents();
  }

  findElements() {
    this.listBox = this.rootElement.querySelector('[data-entity="marquee-box"]');
  }

  saveListBoxInitialDom() {
    this.listBoxInitialDom = this.listBox.innerHTML;

    this.listBoxInitialDom = this.listBoxInitialDom.replace(/lozad/g, '');
    this.listBoxInitialDom = this.listBoxInitialDom.replace(/data-src/g, 'src');
  }

  initUiState() {
    this.uiState = {
      listVisibility: 'hidden',
    };
  }

  init() {
    if (window.innerWidth < this.config.marqueePoint) return;

    this.initMarquee();
  }

  initMarquee() {
    const element = this.rootElement.querySelector('[data-entity="marquee"]');
    this.marquee = new Marquee(element);
  }

  destroyMarquee() {
    this.marquee.destroy();
    this.marquee = null;
    this.listBox.innerHTML = this.listBoxInitialDom;
  }

  attachEvents() {
    const debouncedHandler = debounce(this.windowResizeHandler.bind(this), 400);
    window.addEventListener('resize', debouncedHandler);

    delegate(this.rootElement, '[data-entity="toggler"]', 'click', this.togglerClickHandler.bind(this));
  }

  windowResizeHandler() {
    if (this.uiState.listVisibility === 'hidden' && window.innerWidth >= this.config.marqueePoint) {
      this.initMarquee();
    }

    if (this.marquee && this.uiState.listVisibility === 'shown' && window.innerWidth < this.config.marqueePoint) {
      this.destroyMarquee();
    }
  }

  togglerClickHandler() {
    this.uiState.listVisibility = this.uiState.listVisibility === 'hidden' ? 'shown' : 'hidden';

    this.renderListBox();
  }

  renderListBox() {
    const { listVisibility } = this.uiState;

    if (listVisibility === 'hidden') {
      this.initMarquee();
    }

    if (listVisibility === 'shown') {
      this.destroyMarquee();
    }
  }
}

export default PlacesList;
